import { Component, OnInit } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular';

@Component({
  selector: 'app-trigger',
  templateUrl: './trigger.component.html',
  styleUrls: ['./trigger.component.scss'],
})
export class TriggerComponent implements OnInit {
  /* Declaramos variable que almacenará el loading */
  loading: any;

  constructor(
    private _toast: ToastController,
    private _loading: LoadingController
  ) { }

  ngOnInit() { }

  // Función que desplegará un toast message por pantalla.
  async toastSimple(message: string, color: string) {
    this.loading = true;
    const toast = await this._toast.create({
      message,
      position: 'top',
      color,
      duration: 3000
    });
    toast.present();
  }

  async toastSimplePersistent(message: string, color: string) {
    const toast = await this._toast.create({
      message,
      position: 'top',
      color,
      buttons: [
        {
          text: '✕',
          role: 'cancel',
          handler: () => {
            console.log('Toast cerrado manualmente');
            clearTimeout(autoDismiss); // Cancela el cierre automático si ya lo cerró
          }
        }
      ],
      duration: 0, // No se cierra automáticamente por configuración
      cssClass: 'custom-toast'
    });

    await toast.present();

    // Cierra el toast automáticamente después de 30 segundos (30,000 ms)
    const autoDismiss = setTimeout(() => {
      toast.dismiss().then(() => console.log('Toast cerrado automáticamente tras 30s'));
    }, 10000);
  }



  // Función que desplegará un loading por pantalla.
  async loadingSimple(message: string) {
    this.loading = await this._loading.create({
      message,
      duration: 100
    });
    await this.loading.present();
  }

  // Función que desplegará un loading por pantalla con duración de tiempo.
  async loadingDuration() {
    this.loading = await this._loading.create({
      duration: 1000
    });
    await this.loading.present();
  }

  // Función que desplegará un loading por pantalla.
  async loadingAwait(message: string) {
    this.loading = await this._loading.create({
      message,
      duration: 1500
    });
    await this.loading.present();
  }

  async loadingAwaitForm(message: string): Promise<void> {
    this.loading = await this._loading.create({
      message,
    });
    await this.loading.present();
  }
  async toastSMidle(message: string, color: string) {
    this.loading = true;
    const toast = await this._toast.create({
      message,
      position: 'top',
      color,
      duration: 4000
    });
    toast.present();
  }

  // Función que cerrará el loading desplegado.
  async dismissLoading() {
    this.loading = false;
    return await this._loading.dismiss().then(() => console.log()).catch((error) => {
      console.log('dismissLoading error: ', error);
      this._loading.dismiss();
    });
  }

}